import { createReducer } from '../commons/js/utils/reducer';

const initialState = {
    isLoading: true,
    procurementData: [],
    spoolsData: [],
    spoolsOfFiles: [],
    packageId: "",
    packageMaterialId: "",
    procurementReportPdf: null,
    spoolsReportPdf: null,
    enableOnHold: false,
    haveRevisionLabels: false,
}

export const revisionReportsReducer = createReducer(initialState, {
    "SET_LOADING": (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    "SET_PROCUREMENT_DATA": (state, action) => {
        return {
            ...state,
            procurementData: action.payload.value,
        }
    },
    "SET_SPOOLS_DATA": (state, action) => {
        return {
            ...state,
            spoolsData: action.payload.value,
        }
    },
    "SET_SPOOLS_FILES": (state, action) => {
        return {
            ...state,
            spoolsOfFiles: action.payload.value,
        }
    },
    "SET_PACKAGE_ID": (state, action) => {
        return {
            ...state,
            packageId: action.payload.packageId,
            packageMaterialId: action.payload.packageMaterialId,
        }
    },
    "SET_SPOOLS_REPORT_PDF": (state, action) => {
        return{
            ...state,
            spoolsReportPdf: action.payload.value
        }
    },
    "SET_PROCURE_REPORT_PDF": (state, action) => {
        return{
            ...state,
            procurementReportPdf: action.payload.value,
            enableOnHold: action.payload.enableOnHold,
            haveRevisionLabels: action.payload.haveRevisionLabels,
        }
    }
    
});

export default revisionReportsReducer;